<template>
  <div>
    <confirm-box :dialog="dialog" @confirmed="deleteAdmin" @cancel="cancel" />
    <v-data-table
      :headers="headers"
      :items="townships"
      :loading="loading"
      :items-per-page="itemsPerPage"
      @page-count="pageCount = $event"
      :page.sync="page"
      item-key="id"
      hide-default-footer
      hide-default-header
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Townships</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-select
            class="mr-3"
            v-model="region"
            placeholder="choose region..."
            hide-details=""
            outlined
            dense
            item-text="name"
            item-value="id"
            @change="getTownshipByRgnId"
            :items="regions"
          >
          </v-select>
          <v-select
            v-model="townshipGroup"
            placeholder="choose township group"
            hide-details=""
            outlined
            dense
            item-text="name"
            item-value="id"
            @change="getTownshipByTwnGpId"
            :items="townshipGroups"
          ></v-select>
          <v-spacer></v-spacer>
          <v-btn
            to="/township/add"
            color="teal accent-4"
            depressed
            dark
            class="mb-1"
          >
            <v-icon left dark> mdi-plus-circle-outline </v-icon>
            New Item
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:header="{ props: { headers } }">
        <thead class="header">
          <tr>
            <th
              v-for="header in headers"
              :key="header.text"
              class="header--text"
            >
              {{ header.text }}
            </th>
          </tr>
        </thead>
      </template>

      <template v-slot:item="{ index, item }">
        <tr>
          <td>{{ index + 1 }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.short_code }}</td>
          <td>{{ item.region.name }}</td>
          <td>{{ item.township_group.name }}</td>
          <td>{{ item.both_mdr_picts == 1 ? "No" : "Yes" }}</td>
          <td>
            <div>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="goToOutside(item)"
                    icon
                    color="teal accent-4"
                    v-bind="attrs"
                    v-on="on"
                    class="mr-1 white--text"
                    depressed
                  >
                    <v-icon> mdi-arrow-right-bold-box-outline </v-icon>
                  </v-btn>
                </template>
                <span>go outside township</span>
              </v-tooltip>

              <v-btn
                @click="goUpdateForm(item)"
                icon
                color="orange darken-1"
                class="mr-1 white--text"
                depressed
              >
                <v-icon> mdi-pencil-outline </v-icon>
              </v-btn>
              <v-btn
                @click="openConfrimBox(item)"
                icon
                color="red lighten-1"
                class="white--text"
                depressed
              >
                <v-icon> mdi-delete-outline </v-icon>
              </v-btn>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="text-center py-3">
      <v-pagination
        color="purple accent-4"
        v-model="page"
        :length="pageCount"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ConfirmBox from "@/components/notification/ConfirmBox";

export default {
  props: {
    townships: {
      type: Array,
    },
  },
  components: {
    ConfirmBox,
  },
  data: () => ({
    region: null,
    townshipGroup: null,
    pageCount: 0,
    page: 1,
    itemsPerPage: 5,
    item: {},
    dialog: false,
    headers: [
      { text: "No", value: "no" },
      { text: "Name", value: "name" },
      { text: "Short code", value: "short_code" },
      { text: "Region", value: "region.name" },
      { text: "Township Group", value: "township_group.name" },
      { text: "MDR & PICTS", value: "both_mdr_picts" },
      { text: "Actions", value: "actions", align: "start" },
    ],
  }),
  computed: {
    ...mapState("Loading", ["loading"]),
    ...mapState("TownshipGroup", ["townshipGroups"]),
    ...mapState("Region", ["regions"]),
  },
  methods: {
    getAllTownship() {
      this.$store.dispatch("Township/getTownships");
    },
    goToOutside(item) {
      this.$router.push(`/outside_township/${item.id}`);
    },
    getTownshipByTwnGpId(townshipGroup) {
      this.$store.dispatch("Township/getTownshipByTwnGpId", townshipGroup);
    },
    getTownshipByRgnId(region) {
      this.$store.dispatch("Township/getTownshipByRgnId", region);
    },
    openConfrimBox(item) {
      this.item = item;
      this.dialog = !this.dialog;
    },
    deleteAdmin() {
      let data = {
        id: this.item.id,
      };
      this.$store
        .dispatch("Township/deleteTownship", data)
        .then(() => (this.dialog = !this.dialog));
    },
    cancel() {
      this.dialog = !this.dialog;
    },
    goUpdateForm(item) {
      this.$router.push({
        name: "edit-township",
        params: {
          id: item.id,
        },
      });
    },
  },
  created() {
    this.$store.dispatch("TownshipGroup/getTownshipGroups");
    this.$store.dispatch("Region/getRegions");
  },
};
</script>

<style scoped></style>
